import { useMutation } from '@tanstack/react-query';

import { FlightEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightEventClient = new FlightEventClient(apiBaseUrl);

function useDeleteFightEventDraft() {
  return useMutation({
    mutationKey: [queryKeys.FlightEvent.Delete],
    mutationFn: (id: number) => flightEventClient.delete(id),
  });
}

export default useDeleteFightEventDraft;
